export function initContactModal() {
    const modal = document.querySelector('[data-contact-modal-root]');

    if (!modal) return;

    const dialog = modal.querySelector('[data-contact-modal-dialog]');
    const closeElements = modal.querySelectorAll('[data-contact-modal-close]');
    let lastTrigger = null;

    const open = (trigger) => {
        lastTrigger = trigger || null;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-lock');

        const firstFocusable = dialog?.querySelector('input, textarea, button, select, [href], [tabindex]:not([tabindex="-1"])');
        firstFocusable?.focus();
    };

    const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-lock');
        lastTrigger?.focus();
        lastTrigger = null;
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-contact-modal]');

        if (!trigger) return;

        event.preventDefault();
        open(trigger);
    });

    closeElements.forEach((element) => {
        element.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            close();
        }
    });
}
